export default "__VITE_ASSET__09e5a856__"